import { render, staticRenderFns } from "./AddControlDoctor.vue?vue&type=template&id=e5a71b1a&scoped=true"
import script from "./AddControlDoctor.vue?vue&type=script&lang=js"
export * from "./AddControlDoctor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddControlDoctor.vue?vue&type=style&index=1&id=e5a71b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a71b1a",
  null
  
)

export default component.exports